import React from "react";
import { Alert, AlertTitle, Box } from "@mui/material";

interface NoOptionsAlertProps {
  show: boolean;
  type: "categories" | "weights" | "modality";
  fighterData?: {
    name: string;
    age?: number;
    gender?: string;
    belt?: string;
  };
  categoryName?: string;
}

const NoOptionsAlert: React.FC<NoOptionsAlertProps> = ({
  show,
  type,
  fighterData,
  categoryName,
}) => {
  if (!show) return null;

  const getAlertMessage = () => {
    switch (type) {
      case "categories":
        return (
          <>
            <AlertTitle>Atenção</AlertTitle>
            Não há categorias disponíveis para o atleta{" "}
            <strong>{fighterData?.name}</strong> com base nos filtros aplicados.
            <br />
            <strong>Dados do atleta:</strong> Idade: {fighterData?.age} anos,
            Gênero: {fighterData?.gender}, Faixa: {fighterData?.belt}
          </>

        );
      case "weights":
        return (
          <>
            <AlertTitle>Atenção</AlertTitle>
            Não há opções de peso disponíveis para a faixa{" "}
            <strong>{fighterData?.belt}</strong> na categoria{" "}
            <strong>{categoryName}</strong>.
            {fighterData?.belt && (
              <>
                <br />
                A faixa <strong>{fighterData.belt}</strong> não está habilitada para esta categoria neste evento.
              </>
            )}
          </>
        );
      case "modality":
        return (
          <>
            <AlertTitle>Atenção</AlertTitle>
            Não há modalidades disponíveis para os filtros selecionados.
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning">{getAlertMessage()}</Alert>
    </Box>
  );
};

export default NoOptionsAlert; 